import type { GTMEventDataMapping } from '@corratech/pylot-gtm/src/GTM.d'
import {
    cartState,
    cartItemMapping,
    checkoutStepData,
    orderData,
    pdpData,
    pdpRelatedProductsData,
    pdpUpSellProductsData,
    pdpCrossSellProductsData,
    pdpAddToCartProductsData,
    plpData,
    searchData,
    productClick
} from './events'
import {
    getCartItemPrice,
    getCategoryPath,
    getConfigurableVariant,
    getMapProductDetails,
    getCategoryName
} from './functions'

const cartItemMappingValue = cartItemMapping(
    getCategoryPath,
    getCartItemPrice,
    getConfigurableVariant
)

const cartStateChange = {
    updatedItems: {
        data_source: ['updatedItems'],
        mapping: cartItemMappingValue,
        strict: true
    },
    ...cartState(cartItemMappingValue)
}

const mapProductDetails = getMapProductDetails(getCategoryName)

export const defaultMapping: GTMEventDataMapping = {
    USER_STATE: false,
    USER_LOGIN: false,
    USER_LOGOUT: false,
    CART_VIEW: cartState(cartItemMappingValue),
    CART_STATE: cartState(cartItemMappingValue),
    REMOVE_FROM_CART: cartStateChange,
    ADD_TO_CART: cartStateChange,
    ADD_TO_CART_PDP: pdpAddToCartProductsData(),
    PAGE_VIEW: false,
    PAGE_VIEW_DATA: false,
    TRIGGER_IMMEDIATELY: false,
    PLP: plpData(mapProductDetails, getCategoryName),
    PDP: pdpData(getCategoryPath, getCategoryName),
    PDP_RELATED_PRODUCTS_VIEW: pdpRelatedProductsData(),
    PDP_UP_SELL_PRODUCTS_VIEW: pdpUpSellProductsData(),
    PDP_CROSS_SELL_PRODUCTS_VIEW: pdpCrossSellProductsData(),
    SEARCH: searchData(mapProductDetails),
    PLACE_ORDER: orderData(cartItemMappingValue),
    CHECKOUT: checkoutStepData(cartItemMappingValue),
    PRODUCT_CLICK: productClick(),
    PROMOTION_CLICK: pdpData(getCategoryPath, getCategoryName),
    PROMOTION_VIEW: false,
    CHECKOUT_OPTION: false
}
